import { render, staticRenderFns } from "./Var.affise_vars.vue?vue&type=template&id=0e7e1449&scoped=true&lang=html&"
import script from "./Var.affise_vars.vue?vue&type=script&lang=js&"
export * from "./Var.affise_vars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7e1449",
  null
  
)

export default component.exports